import React, { useEffect, useRef } from 'react';
import './globals.css';
import './scroll-animations.css';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade');
          if (entry.target.dataset.animate === 'slide') {
            entry.target.classList.add('animate-slide');
          }
        }
      });
    }, { threshold: 0.1 });

    sectionRefs.current.forEach(section => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm shadow-md">
        <ul className="container mx-auto flex justify-center gap-8 py-4">
          {['hero', 'about', 'skills', 'projects', 'contact'].map((item) => (
            <li key={item}>
              <a 
                href={`#${item}`}
                className="px-4 py-2 font-medium text-gray-700 hover:text-purple-600 transition-colors duration-300 relative group"
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-600 transition-all duration-300 group-hover:w-full"></span>
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <Hero ref={el => sectionRefs.current[0] = el} />
      <About ref={el => sectionRefs.current[1] = el} />
      <Skills ref={el => sectionRefs.current[2] = el} />
      <Projects ref={el => sectionRefs.current[3] = el} />
      <Contact ref={el => sectionRefs.current[4] = el} />
    </div>
  );
}

export default App;
